export default "__VITE_ASSET__CrQ84XrS__"